export default __webpack_public_path__ + "static/media/fish.553cc798.jpg";